import React from 'react'
import { connect } from 'react-redux'

import { onOpenSideNav } from 'redux/actions/app.actions'
import { Flex, HStack, IconButton } from '@chakra-ui/react'

import { IconMenu } from '_base/Icon'

import AccountNav from '../AccountNav'
import AppNotification from '../AppNotification'

function TopNav({ onOpenSideNav }) {
  return (
    <Flex
      px={{ base: 3, xs: 4, md: 6, lg: 8, xl: 10 }}
      py="2"
      justify={{ base: 'space-between', md: 'flex-end' }}
      align="center"
      position={{ base: 'fixed', md: 'absolute' }}
      bg={{ base: 'brand.front', md: 'transparent' }}
      borderBottomWidth={{ base: '1px', md: 0 }}
      width={{ base: 'full', md: 'auto' }}
      maxW="100vw"
      minH={{ base: '48px', md: '64px' }}
      zIndex="10"
      top="0"
      right="0"
    >
      <IconButton
        aria-label="Open side menu"
        display={{ base: 'flex', md: 'none' }}
        onClick={onOpenSideNav}
        variant="ghost"
        size="md"
        minW="32px"
        w="32px"
        icon={<IconMenu fontSize="24px" />}
      />
      <HStack spacing={{ base: '2', md: '4' }}>
        <AppNotification />
        <AccountNav />
      </HStack>
    </Flex>
  )
}

export default connect(null, {
  onOpenSideNav
})(TopNav)
